import React, { Component } from 'react';
import 'antd/dist/antd.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import AOS from 'aos';
import './Home.css';
import 'aos/dist/aos.css';
import 'aos/dist/aos.js';
import '../../globalcss.css';
import { NavLink } from 'react-router-dom';
import aboutimg1 from '../../Images/aboutimg.jpg';
import bg1 from '../../Images/bg-laptop.jpg';
import bg2 from '../../Images/bg-lappi.jpg';
import coinimg from '../../Images/coin.png';
import globeimg from '../../Images/template.png';
import profileimg from '../../Images/calendar1.png';
import groupimg from '../../Images/group.png';
import eventimg1 from '../../Images/event.png';
import compaignimg from '../../Images/compaign.png';

import catimg from '../../Images/catimg.jpg';
import catimg1 from '../../Images/cat1.jpg';
import catimg2 from '../../Images/cat3.jpg';
import partnerimg1 from '../../Images/partner1.png';
import partnerimg2 from '../../Images/partner2.png';
import partnerimg3 from '../../Images/partner3.png';
import partnerimg4 from '../../Images/partner4.png';
import partnerimg5 from '../../Images/partner5.png';
import mapimg from '../../Images/map.jpg';

import CountTo from 'react-count-to';
import eventimg from '../../Images/event1.png';
import Navbar from '../Navbar/Navbar.js';
import Footer from '../Footer/Footer.js';
import Slider from "react-slick";
import { Row, Col, Button, Icon, Form, Input, Tabs } from 'antd';

const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
function callback(key) {
    console.log(key);
}
class Homecomp extends Component {
    componentDidMount() {
        // function to scrollto top
        // aradhana
        
        window.scrollTo(0, 0)
    }
    constructor(props, context) {
        super(props, context);
        AOS.init();
    }

    componentWillReceiveProps() {
        console.log("home------->",this.props)
        AOS.refresh();
    }

    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1
            
        };
        return (
            <div className="homecontain">
                <div className="homeheader">
                    <div className="homenav">
                        <Navbar></Navbar>
                    </div>
                    <Slider {...settings} className="reactslick">
                        <div>
                            <img src={bg2} className="sliderimg" alt="laptop" />
                            <div className="slidercont flex-column">
                                <p className="logocont"> We Are About Time </p>
                                <p> Managing your time using TapMeNow</p>
                            </div>
                        </div>
                        <div>
                            <img src={bg1} className="sliderimg" alt="laptop" />
                            <div className="slidercont flex-column">
                                <p className="logocont"> We Are About Time </p>
                                <p> Managing your time using TapMeNow </p>
                            </div>
                        </div>
                    </Slider>
                </div>
                {/* about section start */}

                <div className="aboutsec">
                    <Row type="flex" justify="center">
                        <Col lg={{ span: 10 }} xs={{ span: 24 }}>
                            <div className="aboutimg" data-aos="fade-right" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-anchor-placement="center">
                                <img src={aboutimg1} className="sliderimg" alt="About" />
                            </div>
                        </Col>
                        <Col lg={{ span: 10 }} xs={{ span: 24 }}>
                            <div className="about-text flex-column " data-aos="fade-left" data-aos-easing="ease-in-sine" data-aos-duration="600">
                                <h4 className="headercont text-left width100">
                                    About us
                                </h4>
                                <p className="subcont text-left">
                                    Use TapMeNow to effectively manage your time. We extending today’s calendar
                                    functionality through free subcriptions to calendars, events, and alerts published by our particating
                                    users and companies. Provide the following sub sections or pages
                                </p>
                                <p className="subcont text-left"> How it works </p>
                                <p className="subcont text-left"> What’s the cost? </p>
                                <div className="btnsec">
                                    <Button className="abtbtn" type="primary">Primary</Button>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* feature section start */}
                    <div className="featureborder">
                        <div className="featuresec">
                            <Row type="flex" justify="center">
                                <Col lg={{ span: 4 }} xs={{ span: 24 }}>
                                    <div className="featuredtext">
                                        <p className="m0"> Featured Event </p>
                                    </div>
                                </Col>
                                <Col lg={{ span: 5 }} xs={{ span: 24 }}>
                                    <div className="featuredtime">
                                        <p className="m0 timefeature">
                                            07:00 AM - 07:30 AM
                                 </p>
                                        <span > Checkin ticket</span>
                                    </div>
                                </Col>
                                <Col lg={{ span: 5 }} xs={{ span: 24 }}>
                                    <div className="featuredtime">
                                        <p className="m0 timefeature">
                                            07:00 AM - 07:30 AM
                                 </p>
                                        <span > Checkin ticket</span>
                                    </div>
                                </Col>
                                <Col lg={{ span: 5 }} xs={{ span: 24 }}>
                                    <div className="featuredtime">
                                        <p className="m0 timefeature">
                                            07:00 AM - 07:30 AM
                                 </p>
                                        <span > Checkin ticket</span>
                                    </div>
                                </Col>
                                <Col lg={{ span: 5 }} xs={{ span: 24 }}>
                                    <div className="featuredtime">
                                        <p className="m0 timefeature">
                                            07:00 AM - 07:30 AM
                                 </p>
                                        <span > Checkin ticket</span>
                                    </div>
                                </Col>
                            </Row>
                            <div className="fullsec">
                                <Button type="primary">Full Event</Button>
                            </div>
                        </div>
                    </div>
                    {/* feature section start */}
                </div>
                {/* about section End */}

                {/* event detail section start */}
                <div className="eventsection homeeventsec">
                    <div className="container">
                        <Row type="flex" justify="center">
                            <Col lg={{ span: 24 }} xs={{ span: 24 }}>
                                <div className="mainheading ml20">
                                    <span className="one"></span>
                                    <span className="two"></span>
                                    <span className="three"></span>
                                    <span className="four"></span>
                                    <span className="five"></span>
                                    <span className="six"></span>
                                    <div className="subtitle">Events will start in few days</div>
                                    <h3 className="maintitle">calendars</h3>
                                </div>
                            </Col>
                            <Col lg={{ span: 24 }} xs={{ span: 24 }}>
                                <Tabs onChange={callback} type="card">
                                    <TabPane tab="Calendars" key="1">
                                        <Row type="flex" justify="center">
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <p className="white createtext"> Create Event, Calendar, Reminder </p>
                                                        <a className="eventdate" ><NavLink to="/create">Create New</NavLink></a>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tab="Events" key="2">
                                        <Row type="flex" justify="center">
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tab="Compaign" key="3">
                                        <Row type="flex" justify="center">
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <img src={eventimg} className="width100" alt="event" />
                                                        <div className="overlay"></div>
                                                        <a className="imageicon">
                                                            <Icon className="white i1" type="plus" />
                                                        </a>
                                                        <div className="eventdate"> September 1 2018</div>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                                <div className="eventcard">
                                                    <div className="eventimg">
                                                        <p className="white createtext"> Create Event, Calendar, Reminder </p>
                                                        <a className="eventdate" ><NavLink to="/create">Create New</NavLink></a>
                                                    </div>
                                                    <div className="eventtxt">
                                                        <h3> Lorem Ipsum</h3>
                                                        <p>
                                                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                                        </p>
                                                        <p className="float-left"><a className="black">Get ticket</a></p>
                                                        <p className="float-right"><a>upcoming</a></p>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </Tabs>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* event detail section start */}

                {/* Counter section before login start */}
                <div className="countersec">
                    <div className="container">
                        <Row type="flex" justify="space-around">
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="ovaem_skill bg_white">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={profileimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={1535} speed={3535} className="number" />
                                            <div className="name">CALENDARS</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="ovaem_skill bg_white">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={groupimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={267} speed={3535} className="number" />
                                            <div className="name">USERS</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="ovaem_skill bg_white">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={globeimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={333} speed={3535} className="number" />
                                            <div className="name">TEMPLATES</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
                                <div className="ovaem_skill bg_white no_border">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={coinimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={120} speed={3535} className="number" />
                                            <div className="name">SPONSORS</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* Counter section before login end */}

                {/* Counter section after login start */}
                <div className="countersec display-none">
                    <div className="container">
                        <Row type="flex" justify="space-around">
                            <Col lg={{ span: 6 }} xs={{ span: 24 }}>
                                <div className="ovaem_skill bg_white">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={profileimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={1535} speed={3535} className="number" />
                                            <div className="name">CALENDARS</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 24 }}>
                                <div className="ovaem_skill bg_white">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={eventimg1} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={267} speed={3535} className="number" />
                                            <div className="name">EVENTS</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 24 }}>
                                <div className="ovaem_skill bg_white">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={globeimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={333} speed={3535} className="number" />
                                            <div className="name">TEMPLATES</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 6 }} xs={{ span: 24 }}>
                                <div className="ovaem_skill bg_white no_border">
                                    <div className="top flex">
                                        <div className="counterimg">
                                            <img src={compaignimg} alt="profile" className="social_myspace" />
                                        </div>
                                        <div className="inline-block">
                                            <CountTo to={120} speed={3535} className="number" />
                                            <div className="name">COMPAIGN</div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* Counter section after login end */}

                {/* Category section start */}

                <div className="categorysec">
                    <div className="container">
                        <div className="mainheading">
                            <span className="one"></span>
                            <span className="two"></span>
                            <span className="three"></span>
                            <span className="four"></span>
                            <span className="five"></span>
                            <span className="six"></span>
                            <div className="subtitle">Events will start in few days</div>
                            <h3 className="maintitle">Upcoming Events</h3>
                        </div>
                        <Row type="flex" justify="center">
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="categoryimg">
                                    <img src={catimg} alt="category" />
                                    <div className="overlaycat flex bg6">
                                        <p> Concert </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="categoryimg">
                                    <img src={catimg1} alt="category" />
                                    <div className="overlaycat flex bg2">
                                        <p> Conference </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="categoryimg">
                                    <img src={catimg2} alt="category" />
                                    <div className="overlaycat flex bg1">
                                        <p> fest </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="categoryimg">
                                    <img src={catimg} alt="category" />
                                    <div className="overlaycat flex bg4">
                                        <p> Concert </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="categoryimg">
                                    <img src={catimg1} alt="category" />
                                    <div className="overlaycat flex bg3">
                                        <p> conference </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="categoryimg">
                                    <img src={catimg2} alt="category" />
                                    <div className="overlaycat flex bg5">
                                        <p> fest </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* Category section end */}

                {/* Join event section start */}
                <div className="joinevent countersec">
                    <div className="joineventsub">
                        <div className="maintitle white text-center mb1em pb15">JOIN OUR EVENT
                            <span className="one"></span>
                            <span className="two"></span>
                            <span className="three"></span>
                        </div>
                        <div className="subtitle text-center white mt1em">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                            euismod tincidunt ut laoreet dolore magna
                        </div>
                    </div>
                </div>
                {/* Join event section end */}

                {/* New  section start */}
                <div className="eventsection newsec">
                    <div className="container">
                        <div className="mainheading ml20">
                            <span className="one"></span>
                            <span className="two"></span>
                            <span className="three"></span>
                            <span className="four"></span>
                            <span className="five"></span>
                            <span className="six"></span>
                            <div className="subtitle">New Update Magazine</div>
                            <h3 className="maintitle">Latest News</h3>
                        </div>
                        <Row type="flex" justify="center">
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="eventcard">
                                    <div className="eventimg">
                                        <img src={eventimg} className="width100" alt="event" />
                                        <div className="imageicon">
                                            <Icon className="white i1" type="picture" />
                                            <Icon className="white i2" type="arrow-right" />
                                        </div>
                                    </div>
                                    <div className="eventtxt">
                                        <h3> Lorem Ipsum</h3>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodincididunt ut labore et dolore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodincididunt
                                        </p>
                                    </div>
                                    <div className="datesec">
                                        <p className="float-left"> <Icon type="calendar" /> September 1, 2018 </p>
                                        <p className="float-right"> <Icon type="message" /> 0 comments </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="eventcard">
                                    <div className="eventimg">
                                        <img src={eventimg} className="width100" alt="event" />
                                        <div className="imageicon">
                                            <Icon className="white i1" type="picture" />
                                            <Icon className="white i2" type="arrow-right" />
                                        </div>
                                    </div>
                                    <div className="eventtxt">
                                        <h3> Lorem Ipsum</h3>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodincididunt ut labore et dolore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodincididunt
                                        </p>
                                    </div>
                                    <div className="datesec">
                                        <p className="float-left"> <Icon type="calendar" /> September 1, 2018 </p>
                                        <p className="float-right"> <Icon type="message" /> 0 comments </p>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={{ span: 8 }} xs={{ span: 24 }}>
                                <div className="eventcard">
                                    <div className="eventimg">
                                        <img src={eventimg} className="width100" alt="event" />
                                        <div className="imageicon">
                                            <Icon className="white i1" type="picture" />
                                            <Icon className="white i2" type="arrow-right" />
                                        </div>
                                    </div>
                                    <div className="eventtxt">
                                        <h3> Lorem Ipsum</h3>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodincididunt ut labore et dolore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmodincididunt                                        </p>
                                    </div>
                                    <div className="datesec">
                                        <p className="float-left"> <Icon type="calendar" /> September 1, 2018 </p>
                                        <p className="float-right"> <Icon type="message" /> 0 comments </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* News section end */}

                {/* partner section start */}
                <div className="partnersec">
                    <div className="container">
                        <Row type="flex" justify="center">
                            <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                                <div className="partnerimg flex">
                                    <img src={partnerimg1} alt="tapmenow" />
                                </div>
                            </Col>
                            <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                                <div className="partnerimg flex">
                                    <img src={partnerimg2} alt="tapmenow" />
                                </div>
                            </Col>
                            <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                                <div className="partnerimg flex">
                                    <img src={partnerimg3} alt="tapmenow" />
                                </div>
                            </Col>
                            <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                                <div className="partnerimg flex">
                                    <img src={partnerimg4} alt="tapmenow" />
                                </div>
                            </Col>
                            <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                                <div className="partnerimg flex">
                                    <img src={partnerimg5} alt="tapmenow" />
                                </div>
                            </Col>
                            <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                                <div className="partnerimg flex">
                                    <img src={partnerimg3} alt="tapmenow" />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* partner section end */}

                {/* Contact section start */}
                <div className="contactsec flex">
                    <div className="mapimgsec">
                        <img src={mapimg} alt="tapmenow" />
                    </div>
                    <div className="contactform">
                        <p className="contactlogo">
                            Tap<span>Me</span>Now
                            </p>
                        <h3><Icon type="environment-o" />
                            Cesare Rosaroll, 118 80139 Eventine
                            </h3>
                        <h3><Icon type="phone" />
                            +789 558 69 85 +789 023 58 96
                            </h3>
                        <h3><Icon type="mail" />
                            support@example.com
                            </h3>
                    </div>
                </div>
                {/* Contact section end */}

                {/* Newsletter section Start */}
                <div className="newsletter">
                    <div className="container">
                        <Row type="flex" justify="center">
                            <Col lg={{ span: 6 }} xs={{ span: 24 }}>
                                <p className="text-center m0 newshead">To Get Nearly Updates</p>
                            </Col>
                            <Col span={2}>

                            </Col>
                            <Col lg={{ span: 16 }} xs={{ span: 24 }}>
                                <Form layout="inline" className="text-right">
                                    <FormItem className="emailcont">
                                        <Input placeholder="Your Email Address" />
                                    </FormItem>
                                    <FormItem>
                                        <Button type="primary" htmlType="submit">
                                            SIGN UP
                                        </Button>
                                    </FormItem>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>
                {/* Newsletter section end */}

                <Footer></Footer>
            </div>
        );
    }
}

export default Homecomp;


// WEBPACK FOOTER //
// ./src/Component/Home/Home.js